import { DEVICE_ID_STORAGE_KEY } from '../constant/index';
import { NetworkType, PlatformType } from '../constant/common';
export const generateUId = () => {
    const deviceId = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
    return deviceId;
};
export const getDeviceId = () => {
    try {
        let deviceId = window.localStorage.getItem(DEVICE_ID_STORAGE_KEY);
        if (!deviceId) {
            deviceId = generateUId();
            window.localStorage.setItem(DEVICE_ID_STORAGE_KEY, deviceId);
        }
        return deviceId;
    }
    catch (e) { }
};
export const getPlatform = () => {
    const platformRegExp = {
        android: /\bAndroid\s*([^;]+)/,
        ios: /\b(iPad|iPhone|iPod)\b.*? OS ([\d_]+)/,
        windows: /\b(Windows NT)/,
        macos: /\b(Mac OS)/,
        linux: /\b(Linux)/i,
    };
    const isMatchPlatform = (platform) => platformRegExp[platform].test(navigator.userAgent);
    const matchPlatform = Object.keys(platformRegExp).find(isMatchPlatform);
    return matchPlatform ? PlatformType[matchPlatform] : PlatformType.other;
};
export const isAirwallexDomain = () => {
    return /^[a-zA-Z0-9.-]*.airwallex.com$/g.test(window.location.host);
};
export const getNetworkType = () => {
    var _a, _b;
    let netType = '';
    // wechat will inject network type to UA
    const arr = navigator.userAgent.match(/NetType\/(\w+)/);
    if (arr) {
        [, netType] = arr;
        // @ts-ignore:next-line
    }
    else if (navigator === null || navigator === void 0 ? void 0 : navigator.connection) {
        // navigator.connection has compatible issue，ios not supported
        netType =
            // @ts-ignore:next-line
            ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.connection) === null || _a === void 0 ? void 0 : _a.effectiveType) || ((_b = navigator === null || navigator === void 0 ? void 0 : navigator.connection) === null || _b === void 0 ? void 0 : _b.type);
    }
    if (!netType) {
        netType = 'unknown';
    }
    return parseNetType(netType);
};
const parseNetType = (net) => {
    net = String(net).toLowerCase();
    if (net.indexOf('4g') >= 0)
        return NetworkType.net4g;
    if (net.indexOf('wifi') >= 0)
        return NetworkType.wifi;
    if (net.indexOf('5g') >= 0)
        return NetworkType.net5g;
    if (net.indexOf('3g') >= 0)
        return NetworkType.net3g;
    if (net.indexOf('2g') >= 0)
        return NetworkType.net2g;
    return NetworkType.unknown;
};
export const canUseResourceTiming = function () {
    return (typeof window.performance !== 'undefined' &&
        typeof window.performance.clearResourceTimings === 'function' &&
        typeof window.performance.getEntriesByType === 'function' &&
        typeof window.performance.now === 'function');
};
export const canUseWebVitals = function () {
    return typeof window.PerformanceObserver === 'function';
};
export const formatUrl = (url) => {
    if (typeof url === 'string') {
        return url.split('?')[0] || '';
    }
    return url;
};
export const getQueryString = (url) => {
    if (typeof url === 'string') {
        return url.split('?')[1] || '';
    }
    return url;
};
// check is http or https
export const urlIsHttps = (url) => {
    const isHostProtocol = typeof url === 'string' && url.startsWith('//');
    return isHostProtocol ? typeof location !== 'undefined' && location.protocol === 'https:' : /^https/.test(url);
};
// default report value
export var ReportDefaultVal;
(function (ReportDefaultVal) {
    ReportDefaultVal[ReportDefaultVal["number"] = -1] = "number";
    ReportDefaultVal["string"] = "";
})(ReportDefaultVal || (ReportDefaultVal = {}));
// get the report value
export const getReportVal = (rawVal, isDefaultByString) => {
    if (typeof rawVal === 'number') {
        return rawVal;
    }
    if (typeof rawVal === 'string') {
        return rawVal;
    }
    return isDefaultByString ? ReportDefaultVal.string : ReportDefaultVal.number;
};
